import i18n, { initI18n, setLocale } from '@link/share/i18n';
import shareLangEn from '@link/share/i18n/lang/en';
import shareLangJa from '@link/share/i18n/lang/ja';
import shareLangKo from '@link/share/i18n/lang/ko';
import shareLangZh from '@link/share/i18n/lang/zh';
import shareLangZt from '@link/share/i18n/lang/zt';
import { LocaleOption } from '@link/skytree/services/types';
import en from './lang/en';
import ja from './lang/ja';
import ko from './lang/ko';
import zh from './lang/zh';
import zt from './lang/zt';
import overrides from './overrides';

initI18n({
  overrides,
  enText: {
    views: {
      privacy: shareLangEn.privacy,
      terms: shareLangEn.terms,
      booking: shareLangEn.booking,
      ...en.views,
      bookResult: shareLangEn.bookResult
    }
  },
  jaText: {
    views: {
      privacy: shareLangJa.privacy,
      terms: shareLangJa.terms,
      booking: shareLangJa.booking,
      ...ja.views,
      bookResult: shareLangJa.bookResult
    }
  },
  koText: {
    views: {
      privacy: shareLangKo.privacy,
      terms: shareLangKo.terms,
      booking: shareLangKo.booking,
      ...ko.views,
      bookResult: shareLangKo.bookResult
    }
  },
  zhText: {
    views: {
      privacy: shareLangZh.privacy,
      terms: shareLangZh.terms,
      booking: shareLangZh.booking,
      ...zh.views,
      bookResult: shareLangZh.bookResult
    }
  },
  ztText: {
    views: {
      privacy: shareLangZt.privacy,
      terms: shareLangZt.terms,
      booking: shareLangZt.booking,
      ...zt.views,
      bookResult: shareLangZt.bookResult
    }
  }
});

export { setLocale };

export const SHUTTO_LOCALE_OPTIONS = [
  { label: 'Deutsch', value: 'de' },
  { label: 'Français', value: 'fr' },
  { label: 'Español', value: 'es' }
] as const;

export const SHUTTO_LOCALE_VALUES = SHUTTO_LOCALE_OPTIONS.map(
  locale => locale.value
);

export const getLocaleValues = (options: readonly LocaleOption[]): string[] =>
  options.map(locale => locale.value);

export default i18n;
